import React, { useState } from "react";
import { Tab, Tabs } from "carbon-components-react";

import { Indexes } from "@eave/shared/types/api";
import { isProduction } from "config";

import IndexEditor from "./IndexEditor";
import IndexHistory from "./IndexHistory";

const styles = require("./styles.module.scss");

const IndexesPage = () => {
  const [lastUpdated, setLastUpdated] = useState<string | null>(null);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Indexes</h1>
      <Tabs type="container">
        <Tab label="SOFR">
          <IndexEditor
            indexName={Indexes.ThirtyDayAverageSOFR}
            indexLabel={`Current ${Indexes.ThirtyDayAverageSOFR}`}
            linkTitle="NY Fed SOFR Averages"
            linkHref="https://apps.newyorkfed.org/markets/autorates/sofr-avg-ind#TBLDetails"
            updateLastUpdated={setLastUpdated}
          />
          <IndexHistory indexName={Indexes.ThirtyDayAverageSOFR} lastUpdated={lastUpdated} />
        </Tab>
        <Tab label="LIBOR">
          <IndexEditor
            indexName={Indexes.OneYearLIBOR}
            indexLabel="Current WSJ LIBOR"
            linkTitle="WSJ Bonds & Rates"
            linkHref="https://www.wsj.com/market-data/bonds"
            updateLastUpdated={setLastUpdated}
          />
          <IndexHistory indexName={Indexes.OneYearLIBOR} lastUpdated={lastUpdated} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default IndexesPage;
